import styled from 'styled-components';

const ProductListStyled = styled.div`
  background: #ffffff;
  margin-top: 12px;
  border-radius: 12px;
  width: 100%;
  height: 200px;
  overflow: hidden;
  position: relative;
  .season-hot-wrap {
    margin: 28px 0 0 32px;
    display: flex;
    /* align-items:center; */
    gap: 12px;
    span {
      font-size: 18px;
      font-family: 'SourceHanSansCNMedium', sans-serif;
      font-weight: 500;
      color: #424242;
      line-height: 27px;
    }
  }
  .product-scroll-wrap {
    position: relative;
    overflow-x: hidden;
    overflow-y: hidden;
    width: 100%;
    height: 100%;
  }
  .product-wrap {
    width: fit-content;
    bottom: 0;
    top: 0;
    position: absolute;
    left: 0;
    /* padding: 18px 7px 0 7px; */
    .product-display {
      width: fit-content;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      /* overflow-x:scroll; */
      padding-top: 24px;
    }
    .product-box-wrap {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 0 24px;
      border-right: 1px dotted #979797;
      .product-img {
        width: 56px;
        height: 84px;
        object-fit: cover;
        margin-right: 16px;
        flex-shrink: 0;
        border-radius: 4px;
      }
      .product-box {
        display: flex;
        flex-direction: column;
        gap: 4px;
      }
      .product-box-title {
        color: #1f1f24;
        font-size: 14px;
        font-weight: bold;
      }
      .product-box-code {
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 12px;
        color: #73737a;
      }
      .product-box-paa {
        display: flex;
        flex-direction: row;
        gap: 24px;
        white-space: nowrap;
        .paa-item {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          .box-paa {
            color: #808085;
            font-size: 11px;
            display: flex;
            align-items: center;
          }
          .paa-number {
            margin-top: 2px;
            font-size: 14px;
            font-weight: bold;
            color: #1f1f24;
          }
        }
      }
    }
    .product-box-wrap:last-of-type {
      border-right: none;
    }
  }
  .arrow-right,
  .arrow-left {
    position: absolute;
    top: 35%;
    cursor: pointer;
    z-index: 111;
  }
  .arrow-right {
    right: 5px;
  }
  .arrow-left {
    left: 5px;
    transform: rotate(180deg);
  }
  .nodata-wrap {
    height: 50%;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto;
  }
`;

export default ProductListStyled;
